import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../apiSetup/apiCall';

export const fetchEditChargerForm = createAsyncThunk('editCharger/fetchEditChargerForm', async (selectedChargerEdit,  { rejectWithValue }) => {
    try {
        const response = await api.get(`${selectedChargerEdit}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching edit charger form', error);
        throw rejectWithValue(error);
    }
    });

const EditChargerSlice = createSlice({
  name: 'editCharger',
  initialState: {
    data: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEditChargerForm.pending, (state) => {
        state.isLoading = true;
        state.error = false;
      })
      .addCase(fetchEditChargerForm.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(fetchEditChargerForm.rejected, (state, action) => {
        state.isLoading = false;
        state.data = []
        state.error = true
      });
  },
});

export default EditChargerSlice.reducer;
